import React from 'react';
import { Helmet } from 'react-helmet';
import Loader from '../../../components/Loader';

const ReviewInfo = ({ formData, loading }) => {
    if (loading) return <Loader />;

    return (
        <div>
            <Helmet>
                <title>Review Payment Info</title>
                <meta name="description" content="Review your entered bank and personal information before submitting." />
            </Helmet>

            <div className="payout-setup">
                <div className='ws-cl-header'>
                    <div>
                        <h4 className='ws-title'>Review Info before submit</h4>
                    </div>
                </div>

                <div className="po-form-box">
                    <ul className="list-group">
                        {formData.accountType && (
                            <li className="list-group-item d-flex align-items-start">
                                <img 
                                    src='/assets/img/icons/pointer_icon.svg'
                                    className='form-icon img-fluid prdicon'
                                    alt=''
                                />
                                <div><strong>Account Type:</strong> {formData.accountType.title}</div>
                            </li>
                        )}
                        {formData.first_name && formData.last_name && (
                            <li className="list-group-item d-flex align-items-start">
                                <img 
                                    src='/assets/img/icons/pointer_icon.svg'
                                    className='form-icon img-fluid prdicon'
                                    alt=''
                                />
                                <div><strong>Name:</strong> {`${formData.first_name} ${formData.last_name}`}</div>
                            </li>
                        )}
                        {formData.business_name && (
                            <li className="list-group-item d-flex align-items-start">
                                <img 
                                    src='/assets/img/icons/pointer_icon.svg'
                                    className='form-icon img-fluid prdicon'
                                    alt=''
                                />
                                <div><strong>Business Name:</strong> {formData.business_name}</div>
                            </li>
                        )}
                        {formData.role && (
                            <li className="list-group-item d-flex align-items-start">
                                <img 
                                    src='/assets/img/icons/pointer_icon.svg'
                                    className='form-icon img-fluid prdicon'
                                    alt=''
                                />
                                <div><strong>Role:</strong> {formData.role.title}</div>
                            </li>
                        )}
                        {formData.streetAddress && (
                            <li className="list-group-item d-flex align-items-start">
                                <img 
                                    src='/assets/img/icons/pointer_icon.svg'
                                    className='form-icon img-fluid prdicon'
                                    alt=''
                                />
                                <div><strong>Street Address:</strong> {formData.streetAddress}</div>
                            </li>
                        )}
                        {formData.landmark && (
                            <li className="list-group-item d-flex align-items-start">
                                <img 
                                    src='/assets/img/icons/pointer_icon.svg'
                                    className='form-icon img-fluid prdicon'
                                    alt=''
                                />
                                <div><strong>Landmark:</strong> {formData.landmark}</div>
                            </li>
                        )}
                        {formData.city && (
                            <li className="list-group-item d-flex align-items-start">
                                <img 
                                    src='/assets/img/icons/pointer_icon.svg'
                                    className='form-icon img-fluid prdicon'
                                    alt=''
                                />
                                <div><strong>City:</strong> {formData.city}</div>
                            </li>
                        )}
                        {formData.state && (
                            <li className="list-group-item d-flex align-items-start">
                                <img 
                                    src='/assets/img/icons/pointer_icon.svg'
                                    className='form-icon img-fluid prdicon'
                                    alt=''
                                />
                                <div><strong>State:</strong> {formData.state}</div>
                            </li>
                        )}
                        {formData.postalCode && (
                            <li className="list-group-item d-flex align-items-start">
                                <img 
                                    src='/assets/img/icons/pointer_icon.svg'
                                    className='form-icon img-fluid prdicon'
                                    alt=''
                                />
                                <div><strong>Pincode:</strong> {formData.postalCode}</div>
                            </li>
                        )}
                        {formData.bankName && (
                            <li className="list-group-item d-flex align-items-start">
                                <img 
                                    src='/assets/img/icons/pointer_icon.svg'
                                    className='form-icon img-fluid prdicon'
                                    alt=''
                                />
                                <div><strong>Bank Name:</strong> {formData.bankName}</div>
                            </li>
                        )}
                        {formData.accountNumber && (
                            <li className="list-group-item d-flex align-items-start">
                                <img 
                                    src='/assets/img/icons/pointer_icon.svg'
                                    className='form-icon img-fluid prdicon'
                                    alt=''
                                />
                                <div><strong>Account Number:</strong> {formData.accountNumber}</div>
                            </li>
                        )}
                        {formData.ifsCode && (
                            <li className="list-group-item d-flex align-items-start">
                                <img 
                                    src='/assets/img/icons/pointer_icon.svg'
                                    className='form-icon img-fluid prdicon'
                                    alt=''
                                />
                                <div><strong>IFSC:</strong> {formData.ifsCode}</div>
                            </li>
                        )}
                        {formData.panNumber && (
                            <li className="list-group-item d-flex align-items-start">
                                <img 
                                    src='/assets/img/icons/pointer_icon.svg'
                                    className='form-icon img-fluid prdicon'
                                    alt=''
                                />
                                <div><strong>PAN Number:</strong> {formData.panNumber}</div>
                            </li>
                        )}
                        {formData.payoutMethod && (
                            <li className="list-group-item d-flex align-items-start">
                                <img 
                                    src='/assets/img/icons/pointer_icon.svg'
                                    className='form-icon img-fluid prdicon'
                                    alt=''
                                />
                                <div><strong>Payout Method:</strong> {formData.payoutMethod.title}</div>
                            </li>
                        )}
                    </ul>
                </div>

            </div>
        </div>
    );
};

export default ReviewInfo;